import { render, staticRenderFns } from "./officialEventBeltShare.vue?vue&type=template&id=5fc76a8d&scoped=true"
import script from "./officialEventBeltShare.vue?vue&type=script&lang=js"
export * from "./officialEventBeltShare.vue?vue&type=script&lang=js"
import style0 from "./officialEventBeltShare.vue?vue&type=style&index=0&id=5fc76a8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc76a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc76a8d')) {
      api.createRecord('5fc76a8d', component.options)
    } else {
      api.reload('5fc76a8d', component.options)
    }
    module.hot.accept("./officialEventBeltShare.vue?vue&type=template&id=5fc76a8d&scoped=true", function () {
      api.rerender('5fc76a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LittleActivityCreation/components/officialEventBeltShare.vue"
export default component.exports